import { Student } from '../generated/Student';
import { Communicate } from '../generated/Communicate';
import { Payments } from '../generated/Payments';
import { UserAuth } from '../generated/UserAuth';
import { LineProf } from '../generated/LineProf';
import { SupportPlan } from '../generated/SupportPlan';
export class StudentInfoInputDTO {
  student: Student = new Student();
  userAuth: UserAuth = new UserAuth();
  communicate: Communicate = new Communicate();
  payment: Payments = new Payments();
  lineProf: LineProf = new LineProf();
  support_plan: SupportPlan = new SupportPlan();
  buildingName = '';
  buildingId = '';
  total_teacher_count = 0;
  total_lesson_count = 0;
  da_monitoring_state = '';
}
